import { MarcaProduto } from "@/contexts/laboratorio/marcaProduto/model/MarcaProduto";
import { api } from "@/shared/api/api";

export const createMarcaProdutoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<MarcaProduto[]>("/marcas-produto/todas", {
      headers,
    });
    return data;
  };

  return { listAll };
};
